import React, {useState } from 'react'
import gql from 'graphql-tag'
import { useMutation } from '@apollo/react-hooks'
import { Modal, Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
// import PercentBar from './PercentBar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { errorFormatter } from '../utils/errorFunctions'

const reload = () => window.location.reload()

const PUBLISH = gql`
  mutation handleMFActions($input: ManageFileInput!) {
    handleMFActions(input: $input) {
      percent
      error
    }
  }
`
// const PUBLISH_STATUS = gql`
//   query getPublishStatus($input: PublishFileInput!) {
//     publishStatus(input: $input) {
//       percent
//     }
//   }
// `

export default function PublishFileModal(props) {

  const [isLoading, setIsLoading] = useState(false)
  const [isComplete, setIsComplete] = useState(false)
  // const [ showProgress, setShowProgress ] = useState(false)
  // const [ percent, setPercent ] = useState(100)
  const [showClose, setShowClose] = useState(false)
  // const {data, refetch} = useQuery(PUBLISH_STATUS,
  //   {
  //     variables: {
  //       input: {
  //         cuid: props.row.cuid + '',
  //         key: props.itemId + '/'+ props.row.name
  //       }
  //     },
  //     skip:!showProgress
  //   })

  const handleClose = () => {
    props.onHide()
    reload()
  }

  // useEffect(() => {
  //   let interval
  //   if(data && data.publishStatus){
  //     interval = setInterval(() => {
  //       setPercent(data.publishStatus.percent)
  //       if (data.publishStatus.percent >= 100) {
  //         clearInterval(interval)
  //       }
  //       refetch()
  //     }, 1000)}
  //   return () => {
  //     clearInterval(interval)
  //   }
  // }, [refetch, data, setPercent])


  const [ publish] = useMutation(
    PUBLISH,
    {
      variables: {
        input: {
          itemId: props.itemId,
          filename: props.row.name,
          action:props.action,
          pathOnDisk:props.row.pathOnDisk
        }
      },
      onCompleted: ( { handleMFActions}) => {

        if(handleMFActions.percent === 100){
          // props.onHide()
          if(handleMFActions.error){
            errorFormatter(handleMFActions.error)
            console.log('got an error!' + handleMFActions.error)
          }
        // }else{
          // setPercent(handleMFActions.percent)
          // setShowProgress(true)
        }
        setIsLoading(false)
        setIsComplete(true)
      }
    },

  )
  // const renderProgressBar = () => {
  //   if (showProgress) {
  //     return <div >
  //       Published {percent}% <PercentBar percent={percent} />
  //     </div>
  //   } else {
  //     return ''
  //   }
  // }


  return (
    <>
      <Modal {...props} size="lg" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Publish File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit= {e => {
              e.preventDefault()
              setIsLoading(true)
              publish()
              setShowClose(true)
            }}
          >
            <h3>You are about to publish file: {props.row.name}</h3>
            <br/>
            {props.isduplicatefile?
              <p>This ScienceBase item currently already has a file with the same filename in the public S3 location.
            If you elect to publish the selected file, it will overwrite the current file in the public S3 bucket. Proceed?
              </p>:
              <p>The file will be moved to a public bucket. For large files, please note that this may take some time to complete.</p>
            }
            {/* {renderProgressBar()} */}
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>{props.isduplicatefile && !showClose?'Cancel':'Close'}</Button>
              {/* {showProgress?'':<Button variant="primary" type="submit">{props.isduplicatefile?'Yes':'Publish File'}</Button>} */}
              {isComplete?'':<Button variant="primary" type="submit">{isLoading?<span ><FontAwesomeIcon icon={faSpinner} pulse/></span>:''}&nbsp;{props.isduplicatefile?'Yes':'Publish File'}</Button>}
            </Modal.Footer>
          </form>
        </Modal.Body>
      </Modal>

    </>
  )
}

PublishFileModal.propTypes = {
  row: PropTypes.shape({
    cuid: PropTypes.string,
    bucket: PropTypes.string,
    key: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    pathOnDisk: PropTypes.string,
    scrapeMetadata: PropTypes.any,
    status: PropTypes.shape({
      scanPassed: PropTypes.bool
    })
  }),
  itemId: PropTypes.string,
  onHide: PropTypes.func,
  action: PropTypes.string,
  isduplicatefile: PropTypes.bool
}
